const translations = {
  "en": {
    "Bitcoin": "Bitcoin",
    "Ethereum": "Ethereum"
  },
  "zh-tw": {
    "Bitcoin": "比特幣",
    "Ethereum": "以太坊"
  }
};

export default translations;
